import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles/theme.css";

export const leagueTypeStyles = style({
  display: "grid",
  gap: vars.space.xs,
});
